import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import WebIcon from '@material-ui/icons/Web';
import Carousel from './Carousel';
import { ReactComponent as GithubIcon } from '../images/github.svg';
import JMarkdown from './JMarkdown';
import grey from '@material-ui/core/colors/grey';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    title: {
        marginBottom: theme.spacing.unit * 2
    },
    header: {

        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,

        [theme.breakpoints.up('sm')]: {
            paddingTop: theme.spacing.unit ,
            paddingBottom: theme.spacing.unit * 3,
        },

        backgroundColor: theme.palette.custom.headerBack,
        boxShadow: "inset 0 0 20px rgba(0,0,0,.5)",
        
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
        textAlign: 'center'
    },
    description: {
        marginBottom: theme.spacing.unit * 2
    },
    body: {

    },
    white: {
        color: 'white',

    },
    progress: {

        marginTop: theme.spacing.unit * 4,
    },
    sectionMobile: {
        [theme.breakpoints.up("sm")]: {
            display: "none"
          }
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up("sm")]: {
            display: "block"
          },
    },
    markDown: {
        
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,
        maxWidth: '700px',
        textAlign: 'left'

    },

    icon: {
        marginLeft: theme.spacing.unit,
        width: '24px', 
        height: '24px'
    },
    space: {

        marginBottom: theme.spacing.unit,
        
        [theme.breakpoints.up("sm")]: {
            marginTop: theme.spacing.unit,
          }
    },

    button: {

        '&:disabled': {
            backgroundColor: grey[500]
          },

    }

});

class Project extends React.Component {




    render() {

        const { classes, project } = this.props;

        if (project) {
            return (

                <div className={classes.root}>
                    <Grid container direction="column" justify="center" alignItems="center" className={classes.header} >
                        <Grid item className={classes.space}>
                            <Typography variant="h2" className={classes.white} >
                                {project.title}
                            </Typography>
                        </Grid>
                        <Grid item className={classes.space}>
                            <Typography variant="body1" className={classes.white} >
                                {project.description}
                            </Typography>
                        </Grid>
                        <Grid item className={classes.space}>
                            <Carousel images={project.images} />
                        </Grid>
                        <Grid item>
                            <Grid container justify="center" alignItems="center" spacing={8}>
                                <Grid item>
                                    <Button variant="contained" color="secondary" disabled={!project.demoLink} onClick={() => window.open(project.demoLink)}>
                                        Live Demo
                                        <WebIcon className={classes.icon}  />
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" color="primary" disabled={!project.sourceLink} className={classes.button} onClick={() => window.open(project.sourceLink)}>
                                        Repository {!project.sourceLink && ('(private)')}
                                        <GithubIcon className={classes.icon} />
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid container justify="center">
                        <JMarkdown content={project.markDown} />
                    </Grid>
                </div>
            );
        } else {
            return (
                <div className={classes.root}>
                    <Grid container direction="column" justify="center" alignItems="center" className={classes.body} >
                        <CircularProgress color="secondary" size={100} className={classes.progress} />
                    </Grid>
                </div>
            );
        }
    }

}

export default withStyles(styles)(Project);